/* eslint-disable indent */
/* global $ algoliasearch  */
import { GlobalSearch, GlobalSearchOverlay, ProjectSearch, PeopleSearch, VoiceSearch } from './algolia';
import { env } from '../utils';

class Search {
  constructor() {
    this.$body = $('body');
    this.$searchNavTrigger = $('#js-trigger-search-overlay');
    this.searchClient = algoliasearch(env.ALGOLIA_APPLICATION_ID, env.ALGOLIA_SEARCH_API_KEY);
    this.locale = document.getElementById('content').lang;

    this.overlay = null;

    this.init();
  }

  init() {
    if (location.pathname.includes('projects') && this.$body.find('.archive--projects').length) {
      new ProjectSearch(this.searchClient, this.locale);
    }
    if (location.pathname.includes('people') && this.$body.find('.archive--people').length) {
      new PeopleSearch(this.searchClient, this.locale);
    }
    if (location.pathname.includes('voices') && this.$body.find('.archive--voices').length) {
      new VoiceSearch(this.searchClient, this.locale);
    }
    if (location.pathname.includes('search') && this.$body.find('.archive--search').length) {
      new GlobalSearch(this.searchClient, this.locale);
    }

    this.$searchNavTrigger.on('click.searchOverlay', () => {
      this.overlay = new GlobalSearchOverlay(this.searchClient, this.locale);
    });
  }

  deinit() {
    this.$searchNavTrigger.off('click.searchOverlay');
    if (this.overlay) {
      this.overlay.deinit();
    }
  }
}

export default Search;
